<div class="full-container-padding-side-15">
  <div class="flex buttonRow">
    <div class="pull-right">
      @if (isAddUserVisible) {
        <div class="pull-right user-management-button">
          <div>
            <rw-button
              text="ADD USER"
              id="btnCreateNewUser"
              arialabel="add user"
              datapendoid="manage-users-add-user"
              datatestid="manage-users-add-user"
              buttonclass="rw-btn-secondary"
              extraclass="user-management-button"
              iconclass="fa-solid fa-plus"
              [iconrightside]="true"
              [disable]="orgConfig?.InitiatedBillingSeparation"
              placement="left"
              tt_datatestid="adduser-billingseparation-tooltip"
              tt_datapendoid="adduser-billingseparation-tooltip"
              tt_arialabel="Add user billing separation tooltip"
              [rw-tooltip]="addUserToolTip()"
              (clickButton)="createNewUser()"
            ></rw-button>
          </div>
        </div>
      }

      @if (canGenerateReport()) {
        <div class="pull-right user-management-button">
          <rw-button
            text="GENERATE REPORT"
            arialabel="generate report"
            datapendoid="manage-users-generate-report"
            datatestid="manage-users-generate-report"
            buttonclass="rw-btn-tertiary"
            extraclass="user-management-button"
            (clickButton)="generateReport()"
          ></rw-button>
        </div>
      }
      <div class="pull-right user-management-button">
        <div>
          <mat-menu #bulkMenu="matMenu" yPosition="below" xPosition="before" class="custom-menu">
            <div>
              <app-button
                id="manage-users-bulk-send-password-reset-emails"
                data-testid="manage-users-bulk-send-password-reset-emails"
                data-pendo-id="manage-users-bulk-send-password-reset-emails"
                buttonStyle="mat-menu-item"
                (clickActionEmitter)="bulkSendPasswordResetEmails()"
                label="Send Password Reset Emails"
                [disabled]="!isBulkSendPasswordResetEnabled()"
              ></app-button>
            </div>
            <div>
              <app-button
                id="manage-users-bulk-send-activation-emails"
                data-testid="manage-users-bulk-send-activation-emails"
                data-pendo-id="manage-users-bulk-send-activation-emails"
                buttonStyle="mat-menu-item"
                (clickActionEmitter)="bulkReSendActivationEmails()"
                label="Resend Activation Emails"
                [disabled]="!isBulkResendActivationEmailEnabled()"
              ></app-button>
            </div>
            <div>
              <app-button
                id="manage-users-bulk-delete-users"
                data-testid="manage-users-bulk-delete-users"
                data-pendo-id="manage-users-bulk-delete-users"
                buttonStyle="mat-menu-item"
                (clickActionEmitter)="bulkDeleteUsers()"
                label="Delete Users"
                [disabled]="!isBulkDeleteUsersEnabled()"
              ></app-button>
            </div>
          </mat-menu>
          <rw-button
            text="BULK ACTIONS"
            arialabel="bulk user actions"
            datapendoid="manage-users-bulk-actions-menu-button"
            datatestid="manage-users-bulk-actions-menu-button"
            buttonclass="rw-btn-tertiary"
            extraclass="manage-users-bulk-actions-menu-button"
            iconclass="fa-solid fa-caret-down"
            iconrightside="true"
            [matMenuTriggerFor]="isBulkActionsButtonEnabled() ? bulkMenu : null"
            [disable]="!isBulkActionsButtonEnabled()"
            [spin]="bulkActionSpinner"
          ></rw-button>
        </div>
      </div>
    </div>
  </div>
  <div class="flex searchBox">
    <app-search-control
      #userSearchControl
      id="userSearchControl"
      class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
      [Configuration]="searchControlConfiguration"
      (SearchOccurred)="searchOccurred($event)"
      [clearEvent]="clearSearch.asObservable()"
      [searchText]="searchText"
    ></app-search-control>
  </div>
  <div class="flex usersTable">
    <rn-grid
      class="flex-fill"
      [Configuration]="userListGridConfiguration"
      [UniqueId]="'UserID'"
      (rowSelected)="rowSelected($event)"
      (userRowClicked)="navigateToUser($event)"
      (falseyValueClicked)="copyActivationLinkClicked($event)"
      (actionButtonClicked)="actionClickHandler($event)"
      [clearSelected]="clearSelection.asObservable()"
    ></rn-grid>
  </div>
</div>